// extracted by mini-css-extract-plugin
module.exports =  {"root":"DocZx6jGLj3Bz8WbFlxG","sidebar":"Bk3CUlByqCCT5BhkWJ5u"};